import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { AdminService } from '../../../../services/admin/admin.service';
import { EventService } from '../../../../../../../services/event/event.service';
import { UiService } from '../../../../../../../services/ui/ui.service';
import swal from 'sweetalert2';
import { environment } from '../../../../../../../../environments/environment';
import { ExchangeStudentService } from '../../../../services/exchange-student/exchange-student.service';
import { SharedService } from '../../../../services/shared/shared.service';
import { HelperService } from '../../../../../../../services/helper/helper.service';

declare var $;

@Component({
  selector: 'app-add-exchange-student-modal',
  templateUrl: './add-exchange-student-modal.component.html',
  styleUrls: ['./add-exchange-student-modal.component.css'],
  providers: [ExchangeStudentService]
})
export class AddExchangeStudentModalComponent implements OnInit {

  @ViewChild('closeBtn') public closeBtn: ElementRef;

  @Input() type: 'previous-class' | 'alumni' | 'guest' = 'alumni';
  @Output() added = new EventEmitter();

  public students = [];

  public courseId = null;

  public page = 1;
  public totalPages = 0;
  public currentPage = 0;

  public loading = false;
  public searchTerm = '';
  public showingSearchData = false;

  public classList = [];
  public selectedClassId = '';

  private addedStudentIds = [];

  constructor(
    public adminService: AdminService,
    public event: EventService,
    private ui: UiService,
    private sharedService: SharedService,
    private exchangeStudent: ExchangeStudentService,
    private helper: HelperService
  ) { }

  ngOnInit() {
    this.event.on('add-exchange-student-modal', 'showAddExchangeStudentModal', id => {
      this.reset();
      this.searchTerm = '';
      this.selectedClassId = '';
      this.showingSearchData = false;
      this.courseId = id;

      // LOGIC CHANGE: Class list filter logic has been changed as duplicate in_english or Session Year was coming
      this.classList = this.sharedService.classList.filter(C => {
        return C.in_english != this.adminService.embaSession ||
                C.id != this.adminService.classId;
      });
      // ----------------------------------------------------------------------------------------------

      if (this.type === 'guest') {
        this.selectedClassId = 'guest';
        this.getStudents();
      }
    });
  }

  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  private reset() {
    this.students = [];
    this.page = 1;
    this.totalPages = 0;
    this.currentPage = 0;
    this.lastPage = 0;
  }

  getClassList() {
    console.log('get-class-list');
    console.log(this.adminService.classId);
  }

  onClassFocus(e) {

  }

  onClassSelect(e) {
    if (!this.selectedClassId) { return; }
    this.getStudents(true);
  }

  private lastPage = 0;
  getStudents(reset = false) {
    console.log('****************')
    if (reset) { this.reset(); }
    if (this.lastPage === this.page) { return; }
    this.lastPage = this.page;
    const params = {
      page: this.page,
      name: this.showingSearchData ? this.searchTerm : ''
    };
    if (this.selectedClassId === 'guest') {
      (this.page === 1 || reset) ? this.ui.loader.show('add-exchange-student-modal => getStudents') : (this.loading = true);
      this.exchangeStudent.getFromGuestList(
        this.courseId, params,
        (err, res) => {
          (this.page === 1 || reset) ? this.ui.loader.hide('add-exchange-student-modal => getStudents') : (this.loading = false);
          if (err) {
            this.lastPage = this.page - 1;
          } else {
            this.students = [
              ...this.students,
              ...res.data.map(S => {
                S.image = this.helper.getProfileImageUrl(S.image);
                S.saved = res.selected.includes(S.id);
                S.selected = S.saved
                return S;
              })
            ];
            this.page = res.current_page + 1;
            this.currentPage = res.current_page;
            this.totalPages = res.last_page;
          }
        }
      );
    } else {
      console.log(this.page);
      (this.page === 1 || reset) ? this.ui.loader.show('add-exchange-student-modal => getStudents') : (this.loading = true);
      this.exchangeStudent.getByClass(
        this.type === 'previous-class' ? 'student' : 'alumni',
        this.selectedClassId, this.courseId, params,
        (err, res) => {
          (this.page === 1 || reset) ? this.ui.loader.hide('add-exchange-student-modal => getStudents') : (this.loading = false);
          if (err) {
            this.lastPage = this.page - 1;
          } else {
            this.students = [
              ...this.students,
              ...res.data.map(S => {
                S.image = this.helper.getProfileImageUrl(S.image);
                S.saved = !!S.selected;
                return S;
              })
            ];
            this.page = res.current_page + 1;
            this.currentPage = res.current_page;
            this.totalPages = res.last_page;
          }
        }
      );
    }
  }

  selectAll() {
    this.students.forEach(participant => participant.selected = true);
  }

  deselectAll() {
    this.students.forEach(participant => !participant.saved && (participant.selected = false));
  }

  save() {
    this.addParticipants();
  }

  private addParticipants() {
    const payload = {
      my_class_id: this.adminService.classId,
      exchange_class_id: Number(this.selectedClassId),
      course_id: this.courseId,
      user_id: this.students.filter(S => S.selected).map(S => S.id)
    };
    if (payload.user_id.length === 0) {
      swal('Warning!', 'No student selected.', 'warning');
      return;
    }
    if (this.selectedClassId === 'guest') {
      this.ui.loader.show('add-exchange-student-modal => addParticipants');
      this.exchangeStudent.addGuestToCourse(payload, (err, res) => {
        this.ui.loader.hide('add-exchange-student-modal => addParticipants');
        if (err) {
          swal('Error!', err && err[Object.keys(err)[0]] || 'Something went wrong', 'warning');
        } else {
          this.addedStudentIds = this.students.filter(S => !!S.selected);
          this.students.forEach(S => S.saved = !!S.selected);
          this.added.emit();
          swal('Success', 'Students added successfully', 'success');
        }
      });
    } else {
      this.ui.loader.show('add-exchange-student-modal => addParticipants');
      this.exchangeStudent.addToCourse(
        this.type === 'previous-class' ? 'student' : 'alumni',
        payload,
        (err, res) => {
          this.ui.loader.hide('add-exchange-student-modal => addParticipants');
          if (err) {
            swal('Error!', err && err[Object.keys(err)[0]] || 'Something went wrong', 'warning');
          } else {
            this.addedStudentIds = this.students.filter(S => !!S.selected);
            this.students.forEach(S => S.saved = !!S.selected);
            this.added.emit();
            swal('Success', 'Students added successfully', 'success');
          }
        }
      );
    }
  }

  generatePageNumbers() {
    let arr = [];
    for (let i = 1; i <= this.totalPages; i++) { arr.push(i); }
    return arr;
  }

  getName(name) {
    const names = name.trim().split(/\s+|\&nbsp\;/);
    return names.length > 1 ? names[0] + '<br>' + names[names.length - 1] : names[0] + '<br>&nbsp;';
  }

  search() {
    this.reset();
    this.showingSearchData = !!this.searchTerm;
    this.getStudents();
  }

  resetSearch() {
    if (!this.searchTerm) { return; }
    this.searchTerm = '';
    this.search();
  }

  onExchangeStudentSelect(student) {
    // if (!student.saved) { return; }
    // this.confirmDelete(value => {
    //   if (value) {
    //     this.ui.loader.show('add-exchange-student-modal => onExchangeStudentSelect');
    //     this.exchangeStudent.delete(student.exchange_id, (err, res) => {
    //       this.ui.loader.hide('add-exchange-student-modal => onExchangeStudentSelect');
    //       if (err) {
    //         if (Object.keys(err).length) {
    //           swal('Error!', err[Object.keys(err)[0]], 'error');
    //         }
    //       } else {
    //         swal('Success', 'Student successfully removed.', 'success');
    //         student.selected = false;
    //       }
    //     });
    //   } else {
    //     student.selected = true;
    //   }
    // });
  }

  confirmDelete(callback) {
    swal({
      title: 'Are you sure?',
      text: "Click 'Yes' to remove student.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9a4856',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      callback(result.value);
    })
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/programme-details/modals/add-exchange-student-modal/add-exchange-student-modal.component.ts